import React from 'react';
import styled from 'styled-components';
import { standardColours, rangeColours, fontSize } from '../styles';
import { Svg } from './ui';
import careIcon from '../images/care-icon.inline.svg';
import essentialIcon from '../images/essential-icon.inline.svg';
import everyDayIcon from '../images/every-day-icon.inline.svg';
import luxuryIcon from '../images/luxury-icon.inline.svg';

const StyledProductFillingRanges = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

const StyledFilling = styled.span`
  color: ${standardColours.transparentBlack(0.5)};
`;

const StyledRanges = styled.ul``;

const StyledRange = styled.li`
  display: flex;
  align-items: center;
  margin: 5px 0;
  padding: 6px 12px;
  color: ${standardColours.black};
  ${fontSize(12)};
  line-height: 1.1;
  background-color: ${({ range }) =>
    range === 'Care'
      ? rangeColours.care
      : range === 'Essential'
      ? rangeColours.essential
      : range === 'Every Day' || range === 'Everyday'
      ? rangeColours.everyDay
      : rangeColours.luxury};
  border-radius: 6px;

  svg {
    margin-right: 8px;
    height: 13px;
    width: 13px;
  }
`;

const ProductFillingRanges = ({ filling, ranges, isRetailProduct, ...props }) =>
  (filling || ranges.length > 0) &&
  !isRetailProduct && (
    <StyledProductFillingRanges {...props}>
      {filling && <StyledFilling>{filling.value}</StyledFilling>}
      {ranges.length > 0 && (
        <StyledRanges>
          {ranges.map((range, id) => (
            <StyledRange key={id} range={range}>
              <Svg
                image={
                  range === 'Care'
                    ? careIcon
                    : range === 'Essential'
                    ? essentialIcon
                    : range === 'Every Day' || range === 'Everyday'
                    ? everyDayIcon
                    : luxuryIcon
                }
              />
              {range === 'Every Day' ? 'Everyday' : range}
            </StyledRange>
          ))}
        </StyledRanges>
      )}
    </StyledProductFillingRanges>
  );

export default ProductFillingRanges;
